import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminService } from '../services/admin.service';
import { ROUTES } from '../shared/constants';
import { CompanyService } from '../services/company.service';
export const authGuard: CanActivateFn = async (_, { url }) => {
  const authService = inject(AuthService);
  const companyService = inject(CompanyService);
  const router = inject(Router);

  try {
    const isAuth = await authService.isAuthenticated();
    if (!isAuth) {
      router.navigate([ROUTES.USER.LOGIN]);
      return false;
    }
    if (authService.userInfo?.companyId) {
      const companyInfo = await companyService.getCompanyInfo(authService.userInfo?.companyId);
      if(!companyInfo) {
        authService.logout();
        return false;
      }
      return true;
    }
    return true;
  } catch (error) {
    console.error(error);
    authService.clearTokens();
    authService.userInfo = null;
    router.navigate([ROUTES.USER.LOGIN]);
    return false;
  }
};

export const authAdminGuard: CanActivateFn = async (_, { url }) => {
  const adminService = inject(AdminService);
  const router = inject(Router);
  try {
    const isAuth = await adminService.isAuthenticated();
    if (!isAuth) {
      const excludeUrls = [ROUTES.ADMIN.FORGOT_PASSWORD];
      if (excludeUrls.includes(url)) {
        return true;
      }
      router.navigate([ROUTES.ADMIN.LOGIN]);
      return false;
    }
    return true;
  } catch (error) {
    console.error(error);
    adminService.clearTokens();
    adminService.adminInfo = null;
    router.navigate([ROUTES.ADMIN.LOGIN]);
    return false;
  }
};
